// ============================================================================
// Cliente Supabase — MESMO projeto/banco do app mobile (fitclutch-mobile/
// src/lib/supabase.js): mesma URL, mesma chave publishable. É exatamente
// isso que permite a conta criada aqui no funil web (Stripe) já nascer
// ligada à mesma conta que a pessoa vai logar depois no app das lojas.
//
// Diferença da versão mobile: aqui é browser puro (Vite/React), então usa
// `window.localStorage` como storage de sessão, não AsyncStorage do React
// Native. `detectSessionInUrl: true` (diferente do mobile) porque o
// Stripe redireciona de volta pra essa URL depois do checkout — precisa
// deixar o Supabase reconhecer/manter a sessão nesse retorno.
// ============================================================================
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://yemncdchsclzumgwaowr.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_dCKt1T-LgACoVKIo5uFeLg_aG30fwy_';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
